import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryTortugaCustomer = () => {
  return <CategoryBase baseEndpoint="category_tortuga_customer" />;
};

export default CategoryTortugaCustomer;
